var map = {
	"./HK/banner-mobile.png": "S9Kw",
	"./MY-DIGI/banner-mobile.png": "EGXs",
	"./MY/banner-mobile.png": "KKqx",
	"./PH/banner-mobile.png": "F44V",
	"./TW/banner-mobile.png": "+0Yo"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ist";